import DemoWrapper from "../../utils/DemoPageWrapper";
/* eslint-disable import/no-webpack-loader-syntax */
import Demo from "./demo";
import DemoSource from "!!raw-loader!./demo.vue";

const config = {
  props: [
    {
      prop: "visible",
      description: "是否显示 Dialog",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "showWrapper",
      description: "是否显示 遮罩层",
      type: "Boolean",
      default: "true"
    },
    {
      prop: "title",
      description: "Dialog 的标题",
      type: "String"
    },
    {
      prop: "width",
      description: "Dialog 的宽度",
      type: "String",
      default: "50%"
    },
    {
      prop: "maxWidth",
      description: "Dialog 的最大宽度",
      type: "String"
    },
    {
      prop: "height",
      description: "Dialog 的高度",
      type: "String"
    },
    {
      prop: "show-header",
      description: "是否显示头部",
      type: "Boolean",
      default: "true"
    },
    {
      prop: "show-close",
      description: "是否显示关闭按钮",
      type: "Boolean",
      default: "true"
    },
    {
      prop: "show-footer",
      description: "是否显示底部",
      type: "Boolean",
      default: "true"
    },
    {
      prop: "closePosition",
      description: "关闭按钮位置",
      type: "String",
      default: "top",
      available: "top、right"
    },
    {
      prop: "closeOnClickOutside",
      description: "点击外部是否关闭",
      type: "Boolean",
      default: "true"
    },
    {
      prop: "closeOnEsc",
      description: "esc是否关闭",
      type: "Boolean",
      default: "true"
    },
    {
      prop: "lockScroll",
      description: "打开时是否锁定body滚动",
      type: "Boolean",
      default: "true"
    },
    {
      prop: "beforeClose",
      description: "关闭dialog时回调，带有函数参数done",
      type: "Function",
      default: "(done)=>done();"
    },
    {
      prop: "draggable",
      description: "是否可拖拽",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "dragSelector",
      description: "可拖拽选择器",
      type: "String",
      default: ".sj-dialog-header"
    }
  ],
  events: [
    {
      name: "close",
      description: "点击关闭"
    },
    {
      name: "confirm",
      description: "点击确认"
    },
    {
      name: "shown",
      description: "dialog显示触发事件"
    },
    {
      name: "closed",
      description: "dialog关闭触发事件"
    }
  ],
  methods: [],
  slots: []
};

export default DemoWrapper(Demo, DemoSource, config);
